import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://api-inventory.neuromotion.tech/api/v1/sale';

export const sellCartProdcut = createAsyncThunk(
  'sale/sellCartProdcut',
  async (sellCart, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/addSellCart`, sellCart,
        {
            headers: {
              'Content-Type': 'multipart/form-data', // Set content type for file uploads
            },
          }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSaleCart = createAsyncThunk(
  'sale/getSaleCart',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/getsalecart`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSaleCart = createAsyncThunk(
  'sale/deleteSaleCart',
  async (deletedID, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/${deletedID}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const EditSaleCart = createAsyncThunk(
  'sale/EditSaleCart',
  async (saleData, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/`, saleData,
        {
            headers: {
              'Content-Type': 'multipart/form-data', // Set content type for file uploads
            },
          }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const payForSale = createAsyncThunk(
  'sale/payForSale',
  async (payData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/payforsale`,payData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const saleHistory = createAsyncThunk(
  'sale/saleHistory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/history`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const clearSaleBill = createAsyncThunk(
  'sale/clearSaleBill',
  async (clearBilldata, { rejectWithValue }) => {
    try {
      console.log(clearBilldata)
      const response = await axios.post(`${API_URL}/clearbill`,clearBilldata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const saleSlice = createSlice({
  name: 'sale',
  initialState: {
    cart:null,
    salehistory:null,
    loading: false,
    error: null,
    message: false
  },
  reducers: {
       clearError: (state) => {
        state.error = null;
      },
      clearMessage: (state) => {
        state.message = null;
      }
  },
  extraReducers: (builder) => {
    builder.addCase(sellCartProdcut.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sellCartProdcut.fulfilled, (state) => {
      state.loading = false;
      state.message = "Product Add to cart Successfuly";
    });
    builder.addCase(sellCartProdcut.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(getSaleCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSaleCart.fulfilled, (state,action) => {
      state.loading = false;
      state.cart = action.payload.cart;
    });
    builder.addCase(getSaleCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(deleteSaleCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSaleCart.fulfilled, (state,action) => {
      state.loading = false;
      state.message = "Product from order delete succesfuly";
    });
    builder.addCase(deleteSaleCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
      builder.addCase(EditSaleCart.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(EditSaleCart.fulfilled, (state, action) => {
          state.loading = false;
          state.message = "Edit succesfully";
        });
        builder.addCase(EditSaleCart.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.error;
        });
      builder.addCase(payForSale.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(payForSale.fulfilled, (state, action) => {
          state.loading = false;
          state.message = "Add succesfully";
        });
        builder.addCase(payForSale.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.error;
        });
      builder.addCase(saleHistory.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(saleHistory.fulfilled, (state, action) => {
          state.loading = false;
          state.salehistory = action.payload.salehistory;
        });
        builder.addCase(saleHistory.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.error;
        });
      builder.addCase(clearSaleBill.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(clearSaleBill.fulfilled, (state, action) => {
          state.loading = false;
          state.message = action.payload.message;
        });
        builder.addCase(clearSaleBill.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.error;
        });
  }
});
export const { clearError, clearMessage } = saleSlice.actions;

export default saleSlice.reducer;
